<script setup lang="ts">
import CiUpload from '~/components/upload/CiUpload.vue';
</script>

<template>
  <CiUpload />
</template>
